import React from 'react';
import {useSelector} from 'react-redux';

import {RegularCleaningIcon} from '@/components/Icons';
import appConfig from '@/config/appConfig.typed';
import {AD_REMOVE_STICK_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import deviceTypesService from '@/services/device/deviceTypesService';
import {selectDeviceType} from '@/state/selectors/device';

import AdvancedDiagnosticCarouselPage from '../components/AdvancedDiagnosticCarouselPage';
import AdvancedDiagnosticRemoveStickSlides from './AdvancedDiagnosticRemoveStickSlides';

const AdvancedDiagnosticRemoveStick = () => {
    const deviceType = useSelector(selectDeviceType);
    const isDelta = deviceTypesService.isDelta(deviceType);
    const carouselData = appConfig.getAdConfig(deviceType, 'step4');
    const titleItemName = isDelta ? 'removestickdeltatitle' : 'removesticktitle';

    const handleAfterChange = () => {
        amplitudeADTracking.trackADRemoveStickInstructionScroll();
        googleAnalyticsService.trackAdRemoveStickInstructionsScroll();
    };

    return (
        <AdvancedDiagnosticCarouselPage
            icon={<RegularCleaningIcon />}
            slides={() => AdvancedDiagnosticRemoveStickSlides({carouselData})}
            headerTitleKey={AD_REMOVE_STICK_HEADER_TITLE}
            titleItemName={titleItemName}
            onAfterChange={handleAfterChange}
        />
    );
};

export default AdvancedDiagnosticRemoveStick;
